// Copyright (c) 2018 Deere & Company

import LatestPerUnitMeasurements, { getDefaultState } from '../state/latest-per-unit-measurements';
import actions from '../../../../sharedmodules/actions-list';

const resetMeasurements = (state) => LatestPerUnitMeasurements.update(state, {
    $set: getDefaultState(),
});

const updateMeasurements = (state, action) => LatestPerUnitMeasurements.update(state, {
    $set: action.latestPerUnitMeasurements,
});

export default (state = getDefaultState(), action) => {

    const actionTypes = {
        [actions.RESET_LATEST_PER_UNIT_MEASUREMENTS]: resetMeasurements,
        [actions.UPDATE_LATEST_PER_UNIT_MEASUREMENTS]: updateMeasurements,
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};
